module.exports = __webpack_public_path__ + "static/img/user6.1636bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/user6.png
// module id = stbh
// module chunks = 0